module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mu-dialog', {
    attrs: {
      "open": _vm.showDialog,
      "dialogClass": "trainScene",
      "bodyClass": "trainScene-body"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "train-filter"
  }, _vm._l((_vm.filter_items), function(item, index) {
    return _c('span', {
      key: index,
      class: {
        'selected-filter': _vm.selected_filter == index
      },
      on: {
        "click": function($event) {
          _vm.filter_train(index)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "train-classification"
  }, [_c('trainMenu', {
    ref: "trainmenu",
    attrs: {
      "isModal": _vm.isModal,
      "trainCategories": _vm.trainCategories
    },
    on: {
      "category-path-updated": _vm.onTrainCategoryChoose
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "trainScene-content"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "overflow-y": "auto",
      "max-height": "50vh",
      "display": "flex",
      "flex-direction": "column",
      "align-items": "stretch",
      "justify-content": "stretch"
    }
  }, [(_vm.showLoading) ? _c('div', {
    staticClass: "time-train-loading",
    staticStyle: {
      "padding-right": "40px",
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "flex-grow": "1"
    }
  }, [_c('mu-circular-progress', {
    staticClass: "demo-circular-progress",
    attrs: {
      "stroke-width": 5,
      "size": 48
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.showAddPlanRoute) ? _c('div', {
    staticStyle: {
      "padding-right": "40px",
      "text-align": "center",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center",
      "flex-grow": "1"
    }
  }, [_vm._v("当前没有训练方案，"), _c('span', {
    on: {
      "click": function($event) {
        _vm.toTrainPlan(_vm.caseId)
      }
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "underline",
      "cursor": "pointer"
    }
  }, [_vm._v("添加方案")])])]) : _vm._e(), _vm._v(" "), (_vm.noTrain) ? _c('div', {
    staticClass: "no-train"
  }, [_vm._v("更多训练敬请期待")]) : _c('card-list', {
    attrs: {
      "isModal": _vm.isModal,
      "listItems": _vm.currentTrainCategory ? _vm.sortGame(_vm.currentTrainCategory.games) : [],
      "itemComponent": _vm.trainCard
    },
    on: {
      "list-item-clicked": _vm.onTrainClicked
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "height": "48px",
      "position": "absolute",
      "bottom": "0",
      "left": "0",
      "background-color": "#fff",
      "display": "flex",
      "flex-direction": "row",
      "align-items": "center",
      "justify-content": "flex-end"
    }
  }, [_c('mu-raised-button', {
    staticStyle: {
      "position": "absolute",
      "left": "300px",
      "width": "160px",
      "margin-left": "20px",
      "color": "#999"
    },
    attrs: {
      "slot": "actions",
      "label": "取消"
    },
    on: {
      "click": _vm.cancelhandler
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-raised-button', {
    staticStyle: {
      "position": "absolute",
      "left": "600px",
      "width": "160px",
      "margin-left": "20px"
    },
    attrs: {
      "slot": "actions",
      "label": ("去训练 (" + _vm.len + ")"),
      "primary": ""
    },
    on: {
      "click": _vm.goTrain
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    class: [{
      'red': _vm.timeWarn
    }, {
      'orange': !_vm.timeWarn
    }],
    attrs: {
      "slot": "actions",
      "label": _vm.trainCounts,
      "primary": ""
    },
    slot: "actions"
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ecffd65c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/times/timeModalSelect2.vue
// module id = 1031
// module chunks = 2